<div class="modal-overlay">
  <div class="modal-container">

    <!-- Header -->
    <div class="modal-header">
      <div class="header-content">
        <div class="header-icon">
          <i class="material-symbols-rounded">content_copy</i>
        </div>
        <div>
          <h2 class="header-title">Possible Duplicate</h2>
          <p class="header-subtitle">A newly uploaded bill may match one already in your session.</p>
        </div>
      </div>
      <button (click)="onKeep()" class="close-btn" title="Close">
        <i class="material-symbols-rounded">close</i>
      </button>
    </div>

    @if (matchReasons.length > 0) {
      <div class="match-bar">
        <i class="material-symbols-rounded">link</i>
        <span>Matched on:</span>
        @for (reason of matchReasons; track reason) {
          <span class="match-tag">{{ reason }}</span>
        }
      </div>
    }

    <!-- Side-by-side content -->
    <div class="dup-content">

      <!-- Existing Bill -->
      <div class="bill-panel">
        <div class="panel-header">
          <i class="material-symbols-rounded">inventory_2</i>
          <span>Existing Bill</span>
          <span class="panel-period">{{ existingPeriod }}</span>
        </div>
        <div class="bill-meta">
          <div class="meta-item"><span class="meta-label">File</span><span class="meta-value" [title]="existingBill.file.name">{{ existingBill.file.name }}</span></div>
          <div class="meta-item"><span class="meta-label">Provider</span><span class="meta-value">{{ existingBill.data?.providerName || '-' }}</span></div>
          <div class="meta-item"><span class="meta-label">Account</span><span class="meta-value">{{ existingBill.data?.utilityAccountNumber || '-' }}</span></div>
          <div class="meta-item"><span class="meta-label">Amount</span><span class="meta-value bold">{{ existingBill.data?.totalAmount | currency }}</span></div>
        </div>
        <div class="pdf-viewer">
          @if (existingSafeSrc) {
            <iframe [src]="existingSafeSrc" class="pdf-iframe"></iframe>
          } @else {
            <div class="pdf-unavailable">
              <i class="material-symbols-rounded">description</i>
              <p>PDF not available</p>
            </div>
          }
        </div>
      </div>

      <!-- New Upload -->
      <div class="bill-panel new">
        <div class="panel-header new">
          <i class="material-symbols-rounded">upload_file</i>
          <span>New Upload</span>
          <span class="panel-period">{{ newPeriod }}</span>
        </div>
        <div class="bill-meta">
          <div class="meta-item"><span class="meta-label">File</span><span class="meta-value" [title]="newBill.file.name">{{ newBill.file.name }}</span></div>
          <div class="meta-item"><span class="meta-label">Provider</span><span class="meta-value">{{ newBill.data?.providerName || '-' }}</span></div>
          <div class="meta-item"><span class="meta-label">Account</span><span class="meta-value">{{ newBill.data?.utilityAccountNumber || '-' }}</span></div>
          <div class="meta-item"><span class="meta-label">Amount</span><span class="meta-value bold">{{ newBill.data?.totalAmount | currency }}</span></div>
        </div>
        <div class="pdf-viewer">
          @if (newSafeSrc) {
            <iframe [src]="newSafeSrc" class="pdf-iframe"></iframe>
          } @else {
            <div class="pdf-unavailable">
              <i class="material-symbols-rounded">description</i>
              <p>PDF not available</p>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <span class="footer-hint">Compare both documents, then choose an action.</span>
      <div class="footer-actions">
        <button (click)="onKeep()" class="btn-keep">
          <i class="material-symbols-rounded">check_circle</i>
          Keep Both
        </button>
        <button (click)="onDelete()" class="btn-delete">
          <i class="material-symbols-rounded">delete</i>
          Remove New Upload
        </button>
      </div>
    </div>
  </div>
</div>
